// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkCopyLink: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#e00b5a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 15 13" width={width} height={height}>
            <path
                fill="currentColor"
                d="M13.408 5.379a2.95 2.95 0 0 0 0-4.142 2.88 2.88 0 0 0-4.1 0l-.512.517a.37.37 0 0 0 0 .517.36.36 0 0 0 .512 0l.512-.517a2.16 2.16 0 0 1 3.077 0c.849.858.849 2.25 0 3.108L10.074 7.71a2.16 2.16 0 0 1-3.072 0 2.21 2.21 0 0 1-.106-2.989l.12-.14a.37.37 0 0 0-.037-.517.36.36 0 0 0-.512.037l-.12.14a2.95 2.95 0 0 0 .14 3.984 2.877 2.877 0 0 0 4.097 0zm-12.3 0a2.95 2.95 0 0 0 0 4.142 2.88 2.88 0 0 0 4.1 0l.512-.517a.37.37 0 0 0 0-.517.36.36 0 0 0-.512 0l-.512.517a2.16 2.16 0 0 1-3.077 0 2.213 2.213 0 0 1 0-3.108l2.823-2.849a2.16 2.16 0 0 1 3.072 0 2.21 2.21 0 0 1 .106 2.989l-.12.14a.37.37 0 0 0 .037.517.36.36 0 0 0 .512-.037l.12-.14a2.95 2.95 0 0 0-.14-3.984 2.88 2.88 0 0 0-4.101-.004z"
            />
        </svg>
    );
};

export default React.memo(LinkCopyLink);
